import {ref} from 'vue';
import {clientCompanyEndpoints} from '@registry';
import {defineStore} from 'pinia';
import {useLogger, useTranslation} from '#imports';
import {pushVJoySnackbar} from '@maltjoy/core-vue';
import type {ClientCompanyBillingInfoResource, PostClientCompanyBillingInfoRequest} from '@api';

export const useClientCompanyBillingInfosStore = defineStore('client-company-billing-information', () => {
    const logger = useLogger();

    const {t} = useTranslation();

    const clientCompanyBillingInformation = ref<ClientCompanyBillingInfoResource>(null as unknown as ClientCompanyBillingInfoResource);

    const loadingClientCompanyBillingInformation = ref(false);
    const updatingClientCompanyBillingInformation = ref(false);

    async function fetchClientCompanyBillingInformation(companyId: string) {
        try {
            loadingClientCompanyBillingInformation.value = true;
            clientCompanyBillingInformation.value = await clientCompanyEndpoints.getClientCompanyBillingInfo({companyId});
        } catch (e) {
            logger.error(e);
        } finally {
            loadingClientCompanyBillingInformation.value = false;
        }
    }

    async function updateClientCompanyBillingInformation({companyId, clientCompanyBillingInfoParam}: PostClientCompanyBillingInfoRequest) {
        try {
            updatingClientCompanyBillingInformation.value = true;
            loadingClientCompanyBillingInformation.value = true;

            clientCompanyBillingInformation.value = await clientCompanyEndpoints.postClientCompanyBillingInfo({
                companyId,
                clientCompanyBillingInfoParam,
            });
        } catch (e: any) {
            logger.error(e);
            if (e.statusCode === 400) {
                pushVJoySnackbar({props: {message: t('projectclient.billinginformation.approval.formerror'), level: 'warning'}});
            } else {
                pushVJoySnackbar({props: {message: t('projectclient.billinginformation.approval.error'), level: 'error'}});
            }
            return Promise.reject(e);
        } finally {
            updatingClientCompanyBillingInformation.value = false;
            loadingClientCompanyBillingInformation.value = false;
        }
    }

    return {
        fetchClientCompanyBillingInformation,
        updateClientCompanyBillingInformation,
        loadingClientCompanyBillingInformation,
        updatingClientCompanyBillingInformation,
        clientCompanyBillingInformation,
    };
});
